import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const isTodayInTimezone = ({
  timestamp,
  timezone: timezoneName,
}: {
  timestamp: string;
  timezone: string;
}): boolean =>
  dayjs.utc(timestamp).tz(timezoneName).isSame(dayjs().tz(timezoneName), "day");
